import { render, staticRenderFns } from "./LogoEmpresa.vue?vue&type=template&id=20059266&"
var script = {}
import style0 from "./LogoEmpresa.vue?vue&type=style&index=0&id=20059266&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports